<div class="layout">
    <h1>Convertir imagen a webp</h1>
    <div>
        <input type="file" multiple accept="image/*">
    </div>
    <div id="previews"></div>
    <div class="dropTarget"></div>
</div>
